import React, { useEffect, useState } from "react";
import { useGroup } from "../../../../hooks/useGroup";
import { useSubGroup } from "../../../../hooks/useSubGroup";
import empresaApi from "../../../../api/empresaApi";
import {
  Page,
  Left,
  Right,
  HeaderRow,
  RoleListContainer,
  RoleItem,
  SearchInput,
} from "../styles/component.style";
import { BtnGeneral } from "../../../../styles/Buttons";
import SearchableSelect from "../../../../components/Common/SearchableSelect";

export default function SubGroups() {
  const { groups } = useGroup();
  const groupsActive = groups.filter((r) => r.estado === 1 || r.estado === "1" || r.estado === true);
  const {
    subgroups,
    selectedSubGroup,
    handleSelectSubGroups,
    saveSubGroups,
    handleNew,
    setForm,
    form,
    search,
    setSearch,
    loadSubGroup,
    groupSelected,
  } = useSubGroup();

  const [empresas, setEmpresas] = useState([]);
  useEffect(() => {
    empresaApi.getAll().then((res) => {
      setEmpresas(res.data || res || []);
    }).catch(err => console.error(err));
  }, []);
  const LIMITE = 15;
  const filteredSubGroups = subgroups
    .filter(
      (sg) =>
        (sg.descripcion?.toLowerCase() || "").includes(search.toLowerCase()) ||
        (sg.codigo?.toString() || "").includes(search)
    )
    .slice(0, search ? subgroups.length : LIMITE);

  return (
    <Page>
      {/* ================= PANEL IZQUIERDO ================= */}
      <Left>
        <HeaderRow>
          <h3>SubGrupos</h3>
          <BtnGeneral
            bg="cyan"
            padding="6px 10px"
            radius="6px"
            fw="600"
            onClick={handleNew}
          >
            Nuevo
          </BtnGeneral>
        </HeaderRow>

        <label>Filtrar por Grupo</label>
        <SearchableSelect
          key={`filter-group-${groupSelected}`}
          value={groupSelected ? String(groupSelected) : ""}
          onValueChange={(val) => loadSubGroup(val)}
          options={groupsActive.map((g) => ({
            value: String(g.id),
            label: g.descripcion,
          }))}
          placeholder="Seleccione..."
          multiple={false}
          searchable={true}
          size="small"
          sx={{ mb: "6px", ...selectSx }}
        />
        <SearchInput
          placeholder="Buscar x Codigo, Descripcíon..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <RoleListContainer>
          {filteredSubGroups.map((subg) => (
            <RoleItem
              key={subg.id}
              active={selectedSubGroup === subg.id}
              onClick={() => handleSelectSubGroups(subg.id)}
            >
              <strong>
                {subg.codigo} - {subg.descripcion}
              </strong>
            </RoleItem>
          ))}
        </RoleListContainer>
      </Left>

      {/* ================= PANEL DERECHO ================= */}
      <Right>
        <HeaderRow>
          <h5>
            <strong>{form.id ? "Editar subgrupo" : "Nuevo subgrupo"}</strong>
          </h5>
          <BtnGeneral
            bg="green"
            padding="5px 9px"
            radius="6px"
            fw="500"
            onClick={saveSubGroups}
          >
            Guardar
          </BtnGeneral>
        </HeaderRow>

        <div style={{ display: "flex", gap: "20px", marginTop: "2px" }}>
          {/* COLUMNA 1 */}
          <div style={{ flex: 1 }}>
            <label>ID</label>
            <input disabled value={form.id} style={inputStyle} />
            <label>Codigo</label>
            <input
              value={form.codigo}
              onChange={(e) => setForm({ ...form, codigo: e.target.value })}
              style={inputStyle}
            />

            <label>Orden</label>
            <input
              type="number"
              value={form.orden}
              onChange={(e) => setForm({ ...form, orden: e.target.value })}
              style={inputStyle}
            />

            <label>Ver en menu</label>
            <SearchableSelect
              key={`menu-${form.id || "new"}`}
              value={String(form.menu ?? "1")}
              onValueChange={(val) => setForm({ ...form, menu: val })}
              options={[
                { value: "1", label: "SI" },
                { value: "0", label: "NO" },
              ]}
              multiple={false}
              searchable={false}
              size="small"
              sx={{ mb: "6px", ...selectSx }}
            />

            <label>Estado</label>
            <SearchableSelect
              key={`estado-${form.id || "new"}`}
              value={String(form.estado ?? "1")}
              onValueChange={(val) => setForm({ ...form, estado: val })}
              options={[
                { value: "1", label: "ACTIVO" },
                { value: "0", label: "INACTIVO" },
              ]}
              multiple={false}
              searchable={false}
              size="small"
              sx={{ mb: "6px", ...selectSx }}
            />
          </div>

          {/* COLUMNA 2 */}
          <div style={{ flex: 1 }}>
            <label>Grupo</label>
            <SearchableSelect
              key={`grupo-${form.id || "new"}`}
              value={form.idgrupo ? String(form.idgrupo) : ""}
              onValueChange={(val) => setForm({ ...form, idgrupo: val })}
              options={groupsActive.map((g) => ({
                value: String(g.id),
                label: `${g.id} - ${g.descripcion}`,
              }))}
              placeholder="Seleccione..."
              multiple={false}
              searchable={true}
              size="small"
              sx={{ mb: "6px", ...selectSx }}
            />

            <label>Descripcion</label>
            <input
              value={form.descripcion}
              onChange={(e) =>
                setForm({ ...form, descripcion: e.target.value })
              }
              style={inputStyle}
            />
            <label>Visible</label>
            <SearchableSelect
              key={`visible-${form.id || "new"}`}
              value={String(form.visible ?? "1")}
              onValueChange={(val) => setForm({ ...form, visible: val })}
              options={[
                { value: "1", label: "SI" },
                { value: "0", label: "NO" },
              ]}
              multiple={false}
              searchable={false}
              size="small"
              sx={{ mb: "6px", ...selectSx }}
            />

            <label>Empresa</label>
            <SearchableSelect
              key={`empresa-${form.id || "new"}`}
              value={form.id_empresa !== undefined && form.id_empresa !== null ? String(form.id_empresa) : "0"}
              onValueChange={(val) => setForm({ ...form, id_empresa: val })}
              options={[
                { value: "0", label: "Ninguna" },
                ...empresas.map((e) => ({
                  value: String(e.id),
                  label: e.nombre_empresa || e.descripcion || e.nombre || String(e.id),
                })),
              ]}
              placeholder="Seleccione empresa..."
              multiple={false}
              searchable={true}
              size="small"
              sx={{ mb: "6px", ...selectSx }}
            />
          </div>
        </div>
      </Right>
    </Page>
  );
}

const inputStyle = {
  width: "100%",
  padding: "6px",
  marginBottom: "6px",
  borderRadius: "6px",
  border: "1px solid #cbd5e1",
};

const selectSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
    backgroundColor: "#ffffff",
    "& fieldset": { borderColor: "#cbd5e1" },
    "&:hover fieldset": { borderColor: "#94a3b8" },
    "&.Mui-focused fieldset": { borderColor: "#007bba" },
  },
  "& .MuiSelect-select": {
    padding: "6px 10px !important",
    fontSize: "13px",
    fontFamily: "var(--font-body)",
  },
};
